import {Directive, ElementRef, Input, OnChanges, OnInit, Optional, Renderer2, SimpleChanges} from '@angular/core';
import {FormGroupDirective, NgControl} from '@angular/forms';
import {merge} from 'rxjs';

@Directive({
  selector: '[appBorderError]',
})
export class BorderErrorDirective implements OnChanges, OnInit {
  @Input() appBorderError = false;

  readonly control: NgControl | FormGroupDirective;

  constructor(
    private el: ElementRef,
    @Optional() private ngControl: NgControl,
    @Optional() private hostFormGroup: FormGroupDirective,
    private renderer2: Renderer2
  ) {
    this.control = ngControl || hostFormGroup;

    if (!this.control) {
      throw new Error(`Couldn't inject host ngControl for appBorderError directive`);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateClass(changes.appBorderError.currentValue);
  }

  ngOnInit() {
    if (this.control.valueChanges && this.control.statusChanges) {
      merge(this.control.valueChanges, this.control.statusChanges).subscribe(() => {
        this.updateClass(this.appBorderError);
      });
    }
  }

  updateClass(isSubmitted) {
    if (isSubmitted) {
      this.toggleClass();
    } else {
      this.removeClass();
    }
  }

  toggleClass() {
    if (this.control.invalid) {
      this.renderer2.addClass(this.el.nativeElement, 'input_invalid');
    } else {
      this.removeClass();
    }
  }

  removeClass() {
    this.renderer2.removeClass(this.el.nativeElement, 'input_invalid');
  }
}
